import { z } from "zod";

import {
  MAX_LENGTH_MESSAGE,
  MIN_LENGTH_MESSAGE,
  REQUIRED_MESSAGE,
} from "@/utils";

export const userFormSchema = z.object({
  name: z
    .string()
    .min(2, { message: MIN_LENGTH_MESSAGE("2") })
    .max(150, { message: MAX_LENGTH_MESSAGE("150") }),
});

export const userIdSchema = z.object({
  userId: z.string().uuid({ message: REQUIRED_MESSAGE }),
});

export const knowledgeBaseFormSchema = z.object({
  name: z.string().min(2, { message: MIN_LENGTH_MESSAGE("2") }),
  clientId: z.string().uuid({ message: REQUIRED_MESSAGE }),
  files: z.array(z.instanceof(File)).optional(),
});

export type TUserFormData = z.infer<typeof userFormSchema>;
export type TKnowledgeBaseFormData = z.infer<typeof knowledgeBaseFormSchema>;
